<template>
  <div :class="bem()">
    <div
      v-for="spec in visibleTechSpecs"
      :key="spec.id"
      :class="bem('feature')"
    >
      <div :class="bem('feature-container')">
        <div :class="bem('feature-icon-container')">
          <VisionIcon
            :id="'product-tech-specs-' + formatIconName(spec.icon)"
            :icon="formatIconName(spec.icon)"
            colour="black"
            size="medium"
            :class="bem('feature-icon', { icon: formatIconName(spec.icon) })"
          />
        </div>
        <div :class="bem('feature-text')">
          <span :class="bem('feature-title')">
            {{ $tr(spec.label) }}
          </span>
          <!-- eslint-disable vue/no-v-html -->
          <span
            :class="bem('feature-value')"
            v-html="spec.value"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface TechSpecsList {
  customisedProduct: any
}

const props = defineProps<TechSpecsList>()

const bem = useBEM('TechSpecsList')

const techSpecs = computed(() => {
  return (
    props.customisedProduct?.product?.pdpConfigWithDefaults?.techSpecs || []
  )
})

const visibleTechSpecs = computed(() => {
  const newTechSpecs = techSpecs.value.filter((spec) =>
    (lensTech.value || '').match(spec.lensTechFilter || '.*')
  )

  if (props.customisedProduct.frameType === 'ff') {
    newTechSpecs.splice(4, 0, {
      id: 'wind-tech-spec',
      icon: 'antifog',
      label: 'Wind',
      value: 'Complete'
    })
  } else if (['ff', 'tf', 'zf'].includes(props.customisedProduct.frameType)) {
    newTechSpecs.splice(4, 0, {
      id: 'wind-tech-spec',
      icon: 'antifog',
      label: 'Wind',
      value: 'Medium'
    })
  }

  return newTechSpecs.slice(0, 6)
})

const lensTech = computed(() => {
  return props.customisedProduct.lensTech
})

function formatIconName(icon) {
  return icon.replace(/^(sgi-)/, '')
}
</script>

<style lang="postcss" scoped>
.TechSpecsList {
  @apply grid grid-cols-1 gap-x-10 gap-y-4;
}

.TechSpecsList__feature-container {
  @apply flex items-center gap-x-2;
}

.TechSpecsList__feature-icon {
  @apply aspect-square w-6;
}

.TechSpecsList__feature-text {
  @apply text-sm font-medium;
}

.TechSpecsList__feature-title {
  @apply text-grey-500 mr-1;
}
</style>
